var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDj2025(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 294.93 157.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #C9FD67;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M235.1,10.82v135.52c23.38-13.53,39.13-38.8,39.13-67.76h0c0-28.96-15.74-54.23-39.13-67.76Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M156.85,156.83V.32c43.22,0,78.25,35.03,78.25,78.25h0c0,43.22-35.03,78.25-78.25,78.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.35.32h78.25c43.19,0,78.25,35.06,78.25,78.25h0c0,43.19-35.06,78.25-78.25,78.25H.35V.32H.35Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M293.79,78.57c0-19.84-7.39-37.94-19.56-51.73v103.46c12.17-13.79,19.56-31.89,19.56-51.73h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDj2025);
export default __webpack_public_path__ + "static/media/dj2025.f43c22789b65c22524e17257286fb2f6.svg";
export { ForwardRef as ReactComponent };